import { type ReactElement, useEffect } from "react";
import { Navigate, type Location } from "react-router-dom";
import type { UserDto } from "../../api";
import { AppRoutes, createRoute } from "./app_routes";
import { getQueryParam } from "../../utils/urls";
import { showErrorToast, showSuccessToast } from "../../utils/toasts";

export const useRedirects = (
  location: Location,
  user?: UserDto
): ReactElement | null => {
  const emailResetExpired = getQueryParam(
    "email_reset_expired",
    window.location.href
  );
  const emailReset = getQueryParam("email_reset", window.location.href);

  // Check if this is a footer route (legal pages, including sweepstakes rules)
  const isFooterRoute = [
    AppRoutes.TERMS_AND_CONDITIONS,
    AppRoutes.PRIVACY_POLICY,
    AppRoutes.RETURN_POLICY,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ].includes(location.pathname as any);

  useEffect(() => {
    if (emailResetExpired === "1") {
      showErrorToast(
        "Your verification link has expired or was already used. Please request a new one."
      );
    }

    if (emailReset === "1") {
      showSuccessToast("Your email has been updated successfully");
    }
  }, [emailResetExpired, emailReset]);

  // Don't redirect footer routes
  if (isFooterRoute) {
    return null;
  }

  if (emailReset === "1" && user?.id && location.pathname === AppRoutes.INDEX) {
    return <Navigate to={createRoute(AppRoutes.SETTINGS)} />;
  }

  if (
    emailResetExpired === "1" &&
    user?.id &&
    location.pathname === AppRoutes.INDEX
  ) {
    return <Navigate to={createRoute(AppRoutes.SETTINGS)} />;
  }

  return null;
};
